const DB_NAME = 'skjv-storage-blobs';
const DB_VERSION = 1;
const STORE_NAME = 'blobs';
function blobKey(ns, key) {
    return `${ns}/${key}`;
}
function openDb() {
    return new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
            reject(new Error('IndexedDB not available'));
            return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}
export async function putLocalBlob(ns, key, blob, updatedAt) {
    const db = await openDb();
    await new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const rec = { id: blobKey(ns, key), blob, updatedAt };
        const req = store.put(rec);
        req.onsuccess = () => resolve();
        req.onerror = () => reject(req.error);
    });
    db.close();
}
export async function getLocalBlob(ns, key) {
    const db = await openDb();
    const result = await new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const req = tx.objectStore(STORE_NAME).get(blobKey(ns, key));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
    db.close();
    return result?.blob ?? null;
}
//# sourceMappingURL=local-blob.js.map